import { ReactNode, CSSProperties } from "react";
import { C } from "./designTokens";

interface HeadingProps {
  children: ReactNode;
  size?: 1 | 2 | 3;
  light?: boolean;
  style?: CSSProperties;
}

export default function Heading({ children, size = 1, light = false, style = {} }: HeadingProps) {
  const isMobile = window.innerWidth < 768;

  const sizes: Record<number, CSSProperties> = {
    1: {
      fontSize: isMobile ? "2rem" : "clamp(2.5rem, 5vw, 4rem)",
      lineHeight: 1.1,
      fontWeight: 600,
      letterSpacing: "-0.02em",
    },
    2: {
      fontSize: isMobile ? "1.5rem" : "clamp(1.75rem, 3vw, 2.5rem)",
      lineHeight: 1.2,
      fontWeight: 600,
      letterSpacing: "-0.01em",
    },
    3: {
      fontSize: isMobile ? "1.25rem" : "clamp(1.25rem, 2vw, 1.75rem)",
      lineHeight: 1.3,
      fontWeight: 600,
      letterSpacing: "-0.01em",
    },
  };

  return (
    <h2
      style={{
        fontFamily: C.font,
        color: light ? C.white : C.navy,
        margin: 0,
        ...sizes[size],
        ...style,
      }}
    >
      {children}
    </h2>
  );
}
